import { render, staticRenderFns } from "./h-footer.vue?vue&type=template&id=4b78689c&scoped=true"
import script from "./h-footer.vue?vue&type=script&lang=js"
export * from "./h-footer.vue?vue&type=script&lang=js"
import style0 from "./h-footer.vue?vue&type=style&index=0&id=4b78689c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78689c",
  null
  
)

export default component.exports